'use client';

import { CachedGeo } from '@/shared/utils/geo-location/geo-location.type';

export function getGeoLocationOnClient(): CachedGeo | null {
  try {
    const cookieString = document.cookie; // e.g. "geo-location={...}; theme=dark"
    if (!cookieString) return null;

    // Helper to parse cookies
    const cookies = Object.fromEntries(
      cookieString.split('; ').map((c) => {
        const [key, ...v] = c.split('=');
        return [key, decodeURIComponent(v.join('='))];
      }),
    );

    const raw = cookies['geo-location'];
    if (!raw) return null;

    return JSON.parse(raw) as CachedGeo;
  } catch {
    return null;
  }
}
